<template>
  <div :class="wrapperclass">
    <div class="row">
      <label
        :class="'col-form-label ' + labelclass"
        v-if="nolabel !== true"
      >{{ title || '&nbsp;' }}</label>
      <div :class="inputclass">
        <input
          ref="input"
          :maxlength="maxlength"
          :placeholder="placeholder"
          class="form-control"
          v-bind:class="className"
          :required="required ? true : false"
          @change="dataChanged"
          autocomplete="nope"
          :readonly="readonly ? true : false"
          :type="type?type:'text'"
          :step="type?0.1:''"
          :style="inStyle?inStyle:''"
        />
        <span v-if="helptext" class="form-text text-muted">{{ helptext }}</span>
        <label
          v-if="isValid === false"
          id="basic-error"
          class="validation-invalid-label"
          for="basic"
        >{{ this.errormessage || $t('ui.SYS00016') }}</label>
        <label
          v-if="isFormatValid === false"
          id="basic-error"
          class="validation-invalid-label"
          for="basic"
        >{{ $t('message.SYS00002', { digit: digit, decimal: decimal }) }}</label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MobileTextBox",
  props: [
    "id",
    "title",
    "className",
    "wrapperclass",
    "labelclass",
    "inputclass",
    "placeholder",
    "value",
    "maxlength",
    "format",
    "readonly",
    "labelwidth",
    "required",
    "nolabel",
    "helptext",
    "errormessage",
    "allowedInput",
    "type",
    "blurValidation",
    "inStyle",
    "onChange"
  ],
  data() {
    return {
      isValid: true,
      isFormatValid: true,
      digit: 0,
      decimal: 0,
      beforeEditValue: null
    };
  },
  mounted() {
    $(this.$refs.input).val(this.value);

    if (this.allowedInput || this.blurValidation) {
      $(this.$refs.input).on(
        "focus",
        $.proxy(function(e) {
          this.beforeEditValue = $(this.$refs.input).val();
        }, this)
      );
      $(this.$refs.input).on(
        this.allowedInput ? "keyup" : "blur",
        $.proxy(function(e) {
          var re = new RegExp(this.allowedInput || this.blurValidation, "i");
          if (!re.test($(this.$refs.input).val())) {
            this.$nextTick(() => {
              $(this.$refs.input).val(this.beforeEditValue);
              this.$emit("input", this.beforeEditValue, this);
            });
            e.preventDefault();
            e.stopPropagation();
            return false;
          } else {
            this.beforeEditValue = $(this.$refs.input).val();
          }
        }, this)
      );
    }

    if (this.format) {
      $(this.$refs.input).inputmask({
        regex: this.format,
        clearIncomplete: true,
        insertMode: false,
        showMaskOnHover: false
      });

      $(this.$refs.input).on(
        "change",
        $.proxy(function(e) {
          this.$emit("input", $(e.target).val(), this);
        }, this)
      );
    }

    if (this.maxlength) {
      $(this.$refs.input).maxlength({
        threshold: Math.floor(this.maxlength * 0.3)
      });
    }


  },
  methods: {
    setFocus() {
      this.$refs.input.focus();
    },
    setValid(val) {
      this.isValid = val;
    },
    setFormatValid(val) {
      this.isFormatValid = val;
    },
    isFieldValid() {
      var val = $(this.$refs.input).val();
      return (
        !this.required ||
        (this.required && val !== null && val !== undefined && val !== "")
      );
    },
    isFieldFormatValid() {
      return !this.format || (this.format && this.matchFormat());
    },
    dataChanged(e) {
      this.$emit("input", $(e.target).val(), this);
    },
    matchFormat() {
      // Make sure the value matches format given
      if (!$(this.$refs.input).val() || !this.format) {
        return true;
      }

      // var f = this.format.split(',')

      // var re = new RegExp('^(\\d){0,' + f[0] + '}(\\.(\\d){0,' + (f.length > 1 ? f[1] : '0') + '})?$', 'igm')
      var re = new RegExp(this.format, "igm");
      return re.test($(this.$refs.input).val());
    },
    resetValue() {
      this.isValid = true;
      $(this.$refs.input).val(null);
    }
  },
  computed: {
    labelCol() {
      return this.labelwidth || 3;
    }
  },
  watch: {
    value: function(val) {
      $(this.$refs.input).val(val);
      $(this.$refs.input).attr("data-org-value", val);

      this.setValid(this.isFieldValid());
    }
  }
};
</script>
